module.exports = __webpack_public_path__ + "img/Lim.b8283a86.png";